import Vue from "vue"

/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    insuranceDocuments: [],
    paginatedInsuranceDocuments: [],
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {

    getInsuranceDocuments: state => {
        return state.insuranceDocuments
    },
    getPaginatedInsuranceDocuments: state => {
        return state.paginatedInsuranceDocuments
    },

}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */

const mutations = {

    setInsuranceDocuments(state, data) {
        state.insuranceDocuments = data
    },
    setPaginatedInsuranceDocuments(state, data) {
        state.paginatedInsuranceDocuments = data
    },
    createInsuranceDocument(state, data) {
        state.paginatedInsuranceDocuments.data.push(data)
    },
    updateInsuranceDocument(state, data) {
        state.paginatedInsuranceDocuments.data = state.paginatedInsuranceDocuments.data.map(doc => (doc.id == data.id ? { ...doc, ...data } : doc))
    },

}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    setInsuranceDocuments({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/insurance-documents/get-insurance-documents", {all: true}).then(
                response => {
                    commit("setInsuranceDocuments", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setPaginatedInsuranceDocuments({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/insurance-documents/get-insurance-documents", data).then(
                response => {
                    commit("setPaginatedInsuranceDocuments", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    saveInsuranceDocument({ dispatch, commit, state }, data) {

        let formData = data.get('insuranceDocumentForm')
        let insuranceDocumentForm = JSON.parse(formData)

        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/insurance-documents/save-insurance-document", data).then(
                response => {
                    commit("updateInsuranceDocument", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    deleteInsuranceDocument({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/insurance-documents/delete-insurance-document", data).then(
                response => {
                    commit("updateInsuranceDocument", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
